import { render } from "./CstAmend.vue?vue&type=template&id=07c0d734"
import script from "./CstAmend.vue?vue&type=script&lang=js"
export * from "./CstAmend.vue?vue&type=script&lang=js"

import "./CstAmend.vue?vue&type=style&index=0&id=07c0d734&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__